// extracted by mini-css-extract-plugin
export default {"container":"Documents_container__XYPTs"};